import script from "./RepairsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairsComponent.vue?vue&type=script&setup=true&lang=js"

import "./RepairsComponent.vue?vue&type=style&index=0&id=80d2569a&lang=css"

const __exports__ = script;

export default __exports__